<template>
   <span v-if="info.status == 'none'" class="text-muted">-</span>
   <span v-else class="expiry-badge" :class="`expiry-${info.status}`">
      <span>{{ date }}</span>
      <span v-if="!plain && info.status == 'expired'" class="badge bg-danger mx-1">{{ $t('lang_expired') }}</span>
      <span v-else-if="!plain && info.status == 'soon'" class="badge bg-warning text-dark mx-1">{{ $t('lang_expiring_soon') }} ({{ info.days }} {{ $t('lang_days') }})</span>
   </span>
</template>

<script>
import { computed }  from 'vue';
import { useStore }  from 'vuex';
import { getExpiryStatus } from '@/utils/expiry';

export default {
   name: 'ExpiryBadge',

   props: {
      date: {
         type: String,
         default: null,
      },
      plain: {
         type: Boolean,
         default: false,
      },
   },

   setup(props) {
      const store = useStore();

      const info = computed(() => {
         const settings = store.getters['settings/getSettings'] || {};
         return getExpiryStatus(props.date, settings.expiryAlertMonths);
      });

      return { info };
   },
}
</script>

<style scoped>
.expiry-expired { color: #dc3545; font-weight: bold }
.expiry-soon { font-weight: bold }
</style>
